import { clearAuthenticationState } from '@/auth/clearAuthState';
import { CombinedGraphQLErrors, ServerError } from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';

// The error code the backend's Strawberry `IsAuthenticated` permission returns
//  in `errors[].extensions.code` when the session is invalid or expired.
//  Note that the GraphQL endpoint responds with HTTP 200 in this case (auth is
//  enforced per-resolver, not at the view level), so — unlike the REST
//  endpoints, whose 401s are caught by the axios response interceptor — this
//  is the only signal that the session has died.
export const UNAUTHENTICATED_CODE = 'UNAUTHENTICATED';

// Logs the user out when a GraphQL response reports that the session is no
//  longer valid. Without this, a tab whose traffic is mostly Apollo (e.g.
//  polling queries on a backgrounded tab) would keep firing unauthenticated
//  requests forever after the session dies, instead of transitioning to the
//  logged-out state. Clearing the auth state here also propagates to other
//  tabs via the localStorage `storage` event.
export const authErrorLink = new ErrorLink(({ error }) => {
    const isUnauthenticated =
        // In Apollo v4, GraphQL errors arrive wrapped in a CombinedGraphQLErrors.
        (CombinedGraphQLErrors.is(error) &&
            error.errors.some(
                (graphQLError) => graphQLError.extensions?.code === UNAUTHENTICATED_CODE,
            )) ||
        // Belt and braces: also handle the endpoint ever returning a plain 401.
        (ServerError.is(error) && error.statusCode === 401);

    if (isUnauthenticated) {
        clearAuthenticationState();
    }
});
